// import React, { useState } from 'react';
import { Layout } from "react-admin";
import Menu from "./Menu.jsx";
import MyAppBar from './MyAppBar';
// import Fab from "@mui/material/Fab";
// import EditNotificationsIcon from '@mui/icons-material/EditNotifications';

// import Draggable from 'react-draggable';
// import { makeStyles } from '@material-ui/core';
// import { height } from '@mui/system';
// import { ADMIN_DOMAIN, SERVER } from '../constants';

// const PRESS_TIME_UNTIL_DRAG_MS = 250

const MyLayout = (props) => {
  // const [isDragging, setIsDragging] = useState(false);
  // const [isDragging] = useState(false)

  // const handleClick = (event) => {
  //   if (isDragging === true) {
  //     return
  //   }
  //   event.stopPropagation();
  //   // onClick()
  // }


  return (
    <div>

      <Layout
        appBar={MyAppBar}
        {...props}
        menu={Menu}
      >

      </Layout>
      {/* <Draggable
        handle=".handle"
        defaultPosition={{ x: 0, y: 0 }}
        position={null}
        scale={1}
        onStart={() => setTimeout(() => setDragging(true), PRESS_TIME_UNTIL_DRAG_MS)}
        onDrag={e => {
          if (isDragging === false) {
            e.preventDefault()
            return false
          }
        }}
        // onStart={this.handleStart}
        // onDrag={this.handleDrag}
        onStop={e => {
          setDragging(false)
        }}
      >
        <div className="handle" style={{ position: "fixed", left: "190px", bottom: "60px", zIndex: 1000, width: "56px", height: "56px" }}>
          <Fab
            class="hvr-buzz hvr-icon-wobble-vertical"
            style={{
              color: "primary", backgroundColor: "yellow",borderRadius:"10px", width: "56px", height: "56px" ,
            }}

            onClick={(e) => {
              // if (e) { }
              if (isDragging === false) {
                e.preventDefault();
                window.location.href = ADMIN_DOMAIN+"/#/reminder/create";
              }

            }}
                   >
            <EditNotificationsIcon style={{
              color: "primary", backgroundColor: "transparent", width: "36px", height: "36px"
            }}
              color="primary" />

          </Fab>
        </div>
      </Draggable> */}

    </div>

  )
};

export default MyLayout;
